export default __webpack_public_path__ + "img/chevronRight.9aef6421.svg";